import { render, staticRenderFns } from "./AnchorSorter.vue?vue&type=template&id=3453cbdc&"
import script from "./AnchorSorter.vue?vue&type=script&lang=js&"
export * from "./AnchorSorter.vue?vue&type=script&lang=js&"
import style0 from "./AnchorSorter.vue?vue&type=style&index=0&id=3453cbdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports